import { frontendURL } from '../../../helper/URLHelper';
import TeamChatPage from './pages/TeamChatPage.vue';

const meta = {
  permissions: ['team_chat.view'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/team-chat'),
    name: 'team_chat_index',
    component: TeamChatPage,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/team-chat/:channelId'),
    name: 'team_chat_channel',
    component: TeamChatPage,
    meta,
  },
];
